export const DAILY_PLAN_BASE_URL = '/daily-plans';

export const ENDPOINTS = {
  // Task types
  taskTypes: `${DAILY_PLAN_BASE_URL}/tasks/types`,
  callTypes: `${DAILY_PLAN_BASE_URL}/call-types`,
  outcomes: `${DAILY_PLAN_BASE_URL}/outcomes`,
  taskStatuses: `${DAILY_PLAN_BASE_URL}/statuses`,
  comments: `${DAILY_PLAN_BASE_URL}/tasks/:id/comments`,
  changeLogs: `${DAILY_PLAN_BASE_URL}/tasks/:id/change-logs`,
  changeLog: `${DAILY_PLAN_BASE_URL}/tasks/:taskId/change-logs/:id`,

  tasks: `${DAILY_PLAN_BASE_URL}/tasks`,
  task: `${DAILY_PLAN_BASE_URL}/tasks/:id`,
  tasksArchive: `${DAILY_PLAN_BASE_URL}/tasks/archive`,
  tasksRestore: `${DAILY_PLAN_BASE_URL}/tasks/restore`
};
